import React, { useState } from 'react';

import { Button, FormInput, FormSubmitButton, MasterDetailForm, Row, Widget } from '@digital/ui';
import { Modal } from 'antd';
import { AbaPQEscopoMultiplosGestores, updateAssociarPlanilhaQuantidade } from '@app/api/contrato/contratoBase';
import UploadFileNovo from '@app/components/Upload/uploadFileNovo';
import { notification } from '@digital/ui';
interface Props {
  multiplosGestoresEscopo: AbaPQEscopoMultiplosGestores[];
  GetPQMultiplosGestores: () => void;
  isNew: boolean;
  actualValues?: ActualValues;
}

interface ActualValues {
  identificador: number;
  escopo: string;
}

const ModalAdicionaEscopoPQ = (props: Props) => {
  const {multiplosGestoresEscopo, GetPQMultiplosGestores, isNew, actualValues} = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleClose = () => {
    setExibirModal(false);
  };

  const handleCadastraPQ = async (values: any)=>{
    if ((!actualValues || !actualValues.escopo) && !isNew){
      notification.error('Escopo não encontrado!');
     return;
    }
    if (isNew && !values.escopoPQ){
      notification.error('Escopo não encontrado!');
     return;
    }

    let params = {
      contratoId: values.id,
      file: values.formData2,
      identificador: isNew ? multiplosGestoresEscopo.length +1 : actualValues && actualValues.identificador,
      escopo: isNew ? values.escopoPQ : actualValues.escopo,
      isMultiplosGestores: values.isMultiplosGestores,
    };
    updateAssociarPlanilhaQuantidade(params).then(()=>{
      GetPQMultiplosGestores();
    });
    handleClose();
  }

  return (
    <>
      <Button
        type="primary"
        onClick={() => { setExibirModal(true) }}>
        {isNew ? 'Adicionar Planilha de Quantidade(Múltiplos Gestores)' : 'Associar/Atualizar a planilha de quantidade'}
      </Button>
      <Modal title="Multiplos Gestores" width="680px" visible={exibirModal} onCancel={handleClose} footer={null}>
        {exibirModal && (
          <MasterDetailForm
            key="cadPQMultiplosGestores"
            onSubmit={handleCadastraPQ}
            actions={[
              <Button type="link" onClick={handleClose} key="close">
                Cancelar
              </Button>,
              <FormSubmitButton type="primary" key="savePq">
                Confirmar
              </FormSubmitButton>,
            ]}>
            <Widget>
              <Row>
                <FormInput
                  name="identificadorPQ"
                  label="Identificador"
                  span={6}
                  disabled
                  value={`PQ ${isNew ? multiplosGestoresEscopo.length +1 : actualValues && actualValues.identificador}`}
                />
                {isNew ? (
                  <FormInput
                    name="escopoPQ"
                    label="Escopo"
                    span={6}
                    required
                  />
                ) : (
                  <FormInput
                    name="escopoPQ"
                    label="Escopo"
                    span={6}
                    value={actualValues && actualValues.escopo}
                    disabled
                  />
                )}                
              </Row>
              <Row>
                <UploadFileNovo hasFile={false} idDoComponente = {'arquivoPqMG'} accept = ".xlsx, .xls" required={!isNew}/>
              </Row>
            </Widget>
          </MasterDetailForm>
        )}
      </Modal>
    </>
  );
};
export default ModalAdicionaEscopoPQ;
